const obtenerFecha = (): string => {
    const today: Date = new Date();
    const day: number = today.getDate();
    const month: number = today.getMonth() + 1;
    const year: number = today.getFullYear();
    const formattedDay: string = day < 10 ? `0${day}` : `${day}`;
    const formattedMonth: string = month < 10 ? `0${month}` : `${month}`;
    const label = `${year}-${formattedMonth}-${formattedDay}`
    return label;
};

const convertirLetras = (fecha: string): string => {

    try {
        const date = new Date(fecha + "T12:00:00");

        const fechaEnLetras = new Intl.DateTimeFormat("es-MX", {
            weekday: "long",
            day: "numeric",
            month: "long",
            year: "numeric",
        }).format(date);

        return fechaEnLetras;
    } catch (error) {
        return "Esperando datos..."
    }

}

const formato = (fecha: string): string => {
    let array: string[] = fecha.split("-");
    let value: string = `${array[2]}/${array[1]}/${array[0]}`
    return value;
};

const FechaTool = {
    obtenerFecha,
    convertirLetras,
    formato,
};

export default FechaTool;